import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Modal } from '@/components';
import { Button } from '@/ui';

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-between;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
  align-self: center;
`;

export const StyledModal = styled(Modal)`
  &&&& {
    .ant-modal-content {
      width: 110%;
    }

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      justify-content: center;
    }
  }
`;

export const StyledDescription = styled.div`
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
  align-self: center;
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;

  & button {
    width: 100%;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    & button {
      width: auto;
    }
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    display: flex;
    border-radius: 2rem;
    flex: 1;
    cursor: pointer;
  }
`;

export const StyledConfirmButton = styled(Button)`
  &&& {
    flex: 1;
    cursor: pointer;
    background: ${pickThemeColor('DEEP_CRIMSON')} !important;

    .ant-btn-icon {
      display: flex;
    }

    path {
      fill: ${pickThemeColor('WHITE')};
    }
  }
`;
